import { render } from "./TextPlugin.vue?vue&type=template&id=714c6963&scoped=true"
import script from "./TextPlugin.vue?vue&type=script&lang=js"
export * from "./TextPlugin.vue?vue&type=script&lang=js"

import "./TextPlugin.vue?vue&type=style&index=0&id=714c6963&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714c6963"]])

export default __exports__